
import React  from 'react';
export const ForceSlash = () => {
  const unifiedPath =  process.env.NEXT_PUBLIC_UNIFIED_DEFAULT_PATH
  return (
    <script type="text/javascript" dangerouslySetInnerHTML={{
        __html: `
const url = window.location.href;
let newUrl = url;
if(newUrl.split('/').length < 5) {
  newUrl = newUrl.replace(/(https?:[/]{2}[^/]+[/]${unifiedPath}+)([/]?[?]?)/g, '$1/?');
  if(newUrl.endsWith('?')) {
    newUrl = newUrl.slice(0, -1);
  }
}
if(window.location.href !== newUrl) {
  window.location.href = newUrl;
}
`
    }} data-testid="force-slash" />
  );
};

export default ForceSlash;
